import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Purchaseheader } from 'src/app/model/purchaseheader.model';
import { Purchaseline } from 'src/app/model/purchaseline.model';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-addtransportdtls',
  templateUrl: './addtransportdtls.component.html',
  styleUrls: ['./addtransportdtls.component.css']
})
export class AddtransportdtlsComponent implements OnInit {

  orderId: string;
  purchaseData: any;
  purchaseHeader: Purchaseheader;
  data1: any;
  data: Purchaseline[];
  grandTotal: number;

  isUserTransport: boolean;

  constructor(private router: Router, private route: ActivatedRoute,
    private engineeringServices: EngineeringService, private userService: UserService) {
    this.orderId = this.route.snapshot.params.orderid;

    this.userService.isUserTransport.subscribe(
      value => {
        this.isUserTransport = value;
      }
    );

  }

  ngOnInit() {
    this.getOrderById();
  }

  getOrderById() {
    var lineTotal = 0;
    this.grandTotal = 0;
    this.engineeringServices.GetOrderById(this.orderId).subscribe(
      datas => {
        this.purchaseData = datas;
        this.purchaseHeader = this.purchaseData;
        this.data = this.purchaseHeader.purchaseLine;

        for (var i = 0; i < this.data.length; i++) {
          var unicost = this.data[i].unitCost;
          unicost = unicost.replace(/\,/g, '');
          this.data[i].unitCost = unicost;

          var quantty = this.data[i].quantity;
          quantty = quantty.replace(/\,/g, '');
          this.data[i].quantity = quantty;

          lineTotal = parseInt(unicost) * parseInt(quantty);
          this.grandTotal = this.grandTotal + lineTotal;
        }

        console.log(this.purchaseHeader);
      }
    )
  }

  // SubmitTechPriceQuoteForm(form: NgForm) {

  //   this.enquiryHeader.enquiryLine = this.data;
  //   this.enquiryHeader.quoteType = "both";
  //   this.enquiryHeader.id = 0;

  //   for (var i = 0; i < this.enquiryHeader.enquiryLine.length; i++) {
  //     this.enquiryHeader.enquiryLine[i].quoteType = "both";
  //     this.enquiryHeader.enquiryLine[i].vendorNo = this.enquiryHeader.vendorNo;
  //     this.enquiryHeader.enquiryLine[i].id = 0;
  //   }

  //   this.tenderingServices.InviteTechPriceQuote(this.enquiryHeader).subscribe(
  //     data => {
  //       alert("Successfully Submitted");
  //     }
  //   );

  // }
  SubmitTransportDetails(form: NgForm) {
    //alert("SubmitTechPriceQuoteForm")
    debugger;
    form.value.id = this.purchaseHeader.id;
    this.engineeringServices.SubmitTransportDetails(form.value).subscribe(
      (data) => {
        if (data == true) {
          alert("Submitted");
        }
        else {
          alert("An Error Occured");
        }
      }
    )
  }
}